/*
 *###############################################################################
 *Module Name                   : StockFreeze.js                                #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  T A C Priyashad                              #
 *Date                          : Tuesday, February 27th 2022, 1:59:53 pm       #
 *Copyright (c) 2022 myPOS Software Solution (pvt Ltd.)                         #
 *###############################################################################
 */

import React, { useState, useEffect } from "react"
import { MetaTags } from "react-meta-tags"
import {
  Card,
  Col,
  Container,
  TabContent,
  TabPane,
  Row,
  CardBody,
  Alert,
  Button,
} from "reactstrap"

//**Importing required componant files   */
import DPNavBar from "../../../framework/widgets/DPNavBar"
import Breadcrumb from "components/Common/Breadcrumb"
import DPTopToolBar from "framework/widgets/DPTopToolBar"
import DPInfoBox from "framework/layout/DPInfoBox"
import { Text, Numeric } from "../../../framework/validators/TextValidation"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPLoadingAlert from "framework/widgets/DPLoadingAlert"
import DPPermission from "framework/widgets/DPPermission"
import * as XLSX from "xlsx"
import DPPrintOption from "framework/widgets/DPPrintOptions"
import StockFreezeContent from "./StockFreezeContent"
import StockFreezeGroup from "./StockFreezeGroup"
import StockFreezeProducts from "./StockFreezeProducts"
import StockCountSheet from "./StockCountSheet"
import {
  getGroupDetails,
  getLocationSummary,
  getGroupSummary,
  getLocationDets,
  getLocation,
  getSupplier,
  getTxnTypes,
  GetUserWiseLocations,
} from "./StockFreezeController"

import { Context } from '../../../app-contexts/CommonContexts';
import { useHistory } from 'react-router-dom';
import { useContext } from "react"

//**End Importing required componant files */

const StockFreeze = props => {

  let history = useHistory();
  const {
    isHeadOffice, getMenuDetails, addtoFavourite
  } = useContext(Context);
  //*** User input related states */
  const [optionGroup, setoptionGroup1] = useState([])
  const [groupCodeData, setGroupCodeData] = useState([])

  var time = process.env.REACT_APP_ALERTTIMEOUT

  const [menuCode, SetMenuCode] = useState("")

  const [strLocation, SetLocation] = useState("")
  const [strLocationDesc, SetLocationDesc] = useState("")
  const [strBatch, SetBatch] = useState("")
  const [blLocationEnable, SetLocationEnable] = useState(false)
  const [IsLocation, SetIsLocation] = useState(true) //Set Active Location
  const [modal_xlargeLoc, setmodal_xlargeLoc] = useState(false)
  const [addZero, setAddZero] = useState(false)
  const [remarks, setRemarks] = useState("")

  const [strVendor, SetVendor] = useState("")
  const [strVendorDesc, SetVendorDesc] = useState("")
  const [blVendorEnable, SetVendorEnable] = useState(false)
  const [IsVendor, SetIsVendor] = useState(true) //Set Active Vendor
  const [modal_xlargeVen, setmodal_xlargeVen] = useState(false)
  const [clearChange, setClearChange] = useState(false)
  //*** End User input related states */

  //*** Stock Count Sheet Variables*/
  const [FzBatchNo, SetFzBatchNo] = useState("")
  const [FzLoccode, SetFzLoccode] = useState("")
  const [txnType, setTxnType] = useState("")
  const [modal_xlargeB, setmodal_xlargeB] = useState(false)
  const [modal_xlargeL, setmodal_xlargeL] = useState(false)
  //*** End Stock Count Sheet Variables*/

  //*** User Activity related states*/
  const [show, setShow] = useState(false)
  const [AlertMsg, setAlertMsg] = useState("")
  const [AlertColor, setAlertColor] = useState("")
  const [Post, SetPost, getPost] = useState([])
  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [disabledCode, setDisabledCode] = useState(false)
  const [saveEnable, setSaveEnable] = useState(true)
  const [crEnable, setCrEnable] = useState(false)
  const [crBy, setCrBy] = useState("")
  const [mdBy, setMdBy] = useState("")
  const [crDate, setCrDate] = useState("")
  const [mdDate, setMdDate] = useState("")
  const [deleteEnable, SetDeleteEnable] = useState(false)
  const [Reason, setReason] = useState("Created")
  const [editEnable, SetEditEnable] = useState(false)
  //*** End User activity related staes */

  //Alert Parameters
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const [ErrorMsg, setErrorMsg] = useState("")
  const [addNew, SetAddNew] = useState(true)
  const [grpData, setGrpData] = useState([])

  //*****Menu Rights Start*/
  const [menuAccess, SetMenuAccess] = useState(false)
  const [menuCreate, SetMenuCreate] = useState(false)
  const [menuDelete, SetMenuDelete] = useState(false)
  const [menuModify, SetMenuModify] = useState(false)
  const [menuPrint, SetMenuPrint] = useState(false)
  const [menuProcess, SetMenuProcess] = useState(false)
  const [menuName, SetMenuName] = useState("")
  const [parentName, SetParentName] = useState("")
  const [dpAlertShow, SetDpAlertShow] = useState(false)
  const [dpDescription, SetDpDescription] = useState("")
  const [LocationCode, setLocationCode] = useState("")
  const [LogUserType, setLogUserType] = useState("")
  const [LogCompanyCode, setLogCompanyCode] = useState("")
  //*****Menu Rights End */

  /**********Loading Alert */
  const [loadingAlert, SetLoadingAlert] = useState(false)
  const [loadingAlertTitle, SetLoadingAlerttitle] = useState("")
  /**********End Loading Alert */

  //autocode generation related newly added code
  const [codeButton, setCodeButton] = useState(true)
  const [searchdisabled, setSearchdisabled] = useState(false)
  const [nullCode, setNullCode] = useState(false)
  const [autoCode, setAutoCode] = useState(false)

  //User Permission related usestates
  const [permissionAlertShow, setPermissionAlertShow] = useState(false)
  const [permissionAlertTitle, setPermissionAlertTitle] = useState("")
  const [permissionReasonShow, setPermissionReasonShow] = useState(false)
  const [permissionName, setPermissionName] = useState("")
  const [permissionPassword, setPermissionPassword] = useState("")
  const [permissionNameDisable, setPermissionNameDisable] = useState(false)
  const [menu, SetMenu] = useState("")

  const [printoptionShow, setprintoptionShow] = useState(false)

  const [valueUpload, setvalueUpload] = useState("")
  const [items, setItems] = useState([])
  const [Excelitems, setExcelItems] = useState([])

  const [customActiveTab, setcustomActiveTab] = useState("1")

  const [viewRpt, setViewRpt] = useState("1")

  const [txnTypes, setTxnTypes] = useState([])
  const [selectedTxn, setSelectedTxn] = useState("")

  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  const [allLocations, setAllLocations] = useState([])
  const [helpUrl, setHelpUrl] = useState("")

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }

  const tabList = [
    {
      text: "Stock Freeze",
      icon: "fas fa-home",
      tabID: "1",
      onClick: () => {
        toggleCustom("1")
      },
    },
    {
      text: "Stock Count Sheets",
      icon: "far fa-user",
      tabID: "2",
      onClick: () => {
        toggleCustom("2")
      },
    },
  ]

  function tog_xlargeB() {

    if (modal_xlargeB === false && FzLoccode == "") {
      displayAlertMessage('danger', "Please select Location before selecting batch no !")
      return
    }


    setmodal_xlargeB(!modal_xlargeB)
    removeBodyCss()
  }

  function tog_xlargeL() {
    // if (modal_xlargeL === false && FzBatchNo == "") {
    //   setAlertMsg("Please select batch no before selecting location !")
    //   setAlertColor("danger")
    //   setShow(true)
    //   setTimeout(() => {
    //     setShow(false)
    //   }, time)
    //   return
    // }
    setmodal_xlargeL(!modal_xlargeL)
    removeBodyCss()
  }

  const BatchSelect = (e, row) => {
    SetFzBatchNo(row.HED_RUNNO)

    tog_xlargeB()
  }

  const LocationSelect = (e, row) => {
    SetFzLoccode(row.LOC_CODE)
    tog_xlargeL()
  }
  useEffect(() => {
    let data = []
    Excelitems.map(r => {
      data = data.concat({
        strPluCode: r.Code,
        strPluDesc: r.Description,
        dcCost: r.Cost,
        dcSell: r.Sell,
      })
    })
    setGrpData(data)
  }, [Excelitems])


  useEffect(async () => {

    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    const { success, data } = await GetUserWiseLocations(LogUserType, LocationCode);
    if (success) {
      setAllLocations(data)
    } else {
      setAllLocations([])
    }
  }, [])



  function tog_xlargeLoc() {
    setmodal_xlargeLoc(!modal_xlargeLoc)
    removeBodyCss()
  }

  function tog_xlargeVen() {
    setmodal_xlargeVen(!modal_xlargeVen)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  //*** Get user selected row details */
  const GetSelectRowLoc = (e, row, isSelect, rowIndex) => {

    getLocations(row.LOC_CODE)
    tog_xlargeLoc()

  }

  const GetSelectRowVen = (e, row, isSelect, rowIndex) => {
    getSuppliers(row.SM_CODE)
    tog_xlargeVen()
  }

  useEffect(async () => {
    var code = "0"
    let Datalan3 = await getGroupSummary(code)
    setoptionGroup1(Datalan3)

    var grpCodeJson = []
    if (Datalan3.length > 0) {
      Datalan3.map((item, index) => {
        grpCodeJson.push({
          Group: item.GRP_CODE,
          Values: []
        })
      })
    }
    setGroupCodeData(grpCodeJson)


    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    SetParentName(parentname)
    var LocationCode = obj[3]
    var CompanyCode = obj[5]
    SetMenu(menu)
    setLocationCode(LocationCode)
    setLogUserType(LogUserType)
    setLogCompanyCode(CompanyCode)
    var myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")
    myHeaders.append("Authorization", `Bearer ${authToken}`)


    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    }

    fetch(`${ApiURL}login/menu/${LogUserType}/${menu}`, requestOptions)
      .then(response => response.json())
      .then(result => {
        setPermissionReasonShow(result.data.strMenuReasonShow)
        SetMenuAccess(result.data.strMenuAccessRight)
        SetMenuCreate(result.data.strMenuCreateRight)
        SetMenuDelete(result.data.strMenuDeleteRight)
        SetMenuModify(result.data.strMenuModifyRight)
        SetMenuPrint(result.data.strMenuPrintRight)
        SetMenuProcess(result.data.strMenuProcessRight)
        SetMenuName(result.data.strMenuName)
        SetMenuCode(result.data.strMenuTag)
        setHelpUrl(result.data.strHelpUrl)
        fetch(`${ApiURL}common/autocode/${result.data.strMenuTag}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        })
          .then(Response => Response.json())
          .then(responseData => {
            if (responseData.success == true) {
              if (responseData.data.length == 0) {
                setNullCode(true)
              } else {
                setAutoCode(responseData.data)
                SetFzBatchNo(responseData.data.toString())
              }
            }
          })
      })
      .catch(error => console.log("error", error))

    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]
    var LocationCode = obj[3]
    var LocationName = obj[4]
    var CompanyCode = obj[5]
    var menuDetail = await getMenuDetails(window.location.pathname)
    var menu = menuDetail && menuDetail.menuTag ? menuDetail.menuTag : history.push('/dashboard');
    var parentname = menuDetail?.parentName
    var menuTAG = ""
    const AuditLog = {
      strMenuCode: menu,
      strUserName: LogUserType,
      strLocCode: LocationCode,
      strComcode: CompanyCode,
      strReason: "",
    }
    var requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(AuditLog),
    }

    fetch(`${ApiURL}login/menu/audit`, requestOptions)
      .then(async response => await response.json())
      .then(result => {
        console.log(result)
      })
      .catch(error => console.log("error", error))
  }, [])

  useEffect(async () => {
    const txnTypes = await getTxnTypes()
    setTxnTypes(txnTypes)
  }, [])


  const readExcel = file => {
    //debugger;
    const promise = new Promise((resolve, reject) => {
      //debugger;
      const fileReader = new FileReader()
      fileReader.readAsArrayBuffer(file)

      fileReader.onload = e => {
        //debugger;
        const bufferArray = e.target.result
        const wb = XLSX.read(bufferArray, { type: "buffer" })
        const wsname = wb.SheetNames[0]
        const ws = wb.Sheets[wsname]
        const data = XLSX.utils.sheet_to_json(ws)
        setExcelItems(data)
        resolve(data)
      }

      fileReader.onerror = error => {
        reject(error)
      }
    })

    promise.then(d => {
      debugger
      setItems(d)
    })
  }



  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const loadItems = async () => {
    if (strLocation.length == 0) {
      displayAlertMessage('danger', `Please Select location before load items !`)
      return
    }
    // if (strVendor.length == 0) {
    //   setAlertColor("danger")
    //   setAlertMsg(`Please Select supplier before load items !`)
    //   setShow(true)
    //   setTimeout(() => {
    //     setShow(false)
    //   }, time)
    //   return
    // }

    let lstGroups = []
    lstGroups = await LoadSelectedGroups()

    if (lstGroups.length == 0) {
      displayAlertMessage('danger', `Please Select Group before load items !`)
      return
    }

    fetChData(strLocation, strVendor, lstGroups)
  }

  const LoadSelectedGroups = async () => {
    let exsisit = []
    let tbl = document.getElementById("GroupDet")
    if (tbl != null) {
      let rowCount = tbl.tBodies[0].rows.length
      for (let i = 0; i < rowCount; i++) {
        let grpID = document.getElementById("txtCode" + i).value.trim()
        let grpCode = document.getElementById("txtGroupcode" + i).value.trim()
        if (grpCode != "") {
          //convert this 001,002,003 to '001','002','003'
          let arr = grpCode.split(",")
          let str = ""
          for (let i = 0; i < arr.length; i++) {
            if (i == 0) {
              str = "'" + arr[i] + "'"
            } else {
              str = str + ",'" + arr[i] + "'"
            }
          }
          grpCode = str
          exsisit.push({
            Group: grpID,
            Values: grpCode,
          })
        }
      }
    }
    return exsisit
  }

  const fetChData = async (strLocSQL, strVenSQL, lstGroups) => {

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Loading Products...")

    var myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json")
    myHeaders.append("Authorization", `Bearer ${authToken}`)
    var raw = JSON.stringify({
      strLoc: strLocSQL,
      strVen: strVenSQL,
      lstGrpSet: lstGroups,
    })

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: raw,
    }

    fetch(`${ApiURL}txn/freeze`, requestOptions)
      .then(response => response.json())
      .then(result => {
        SetLoadingAlert(false)
        if (result.success == true) {
          setGrpData(result.data)
        } else {
          setGrpData(result.data)
          displayAlertMessage('danger', "No Data Found !")
        }


      })
      .catch(error => {
        SetLoadingAlert(false)
        console.log("error", error)
      })
  }

  //save button function
  const handlesave = async e => {


    if (customActiveTab == "2" && viewRpt == '4') { //call Post Stock Adjustment function

      if (FzBatchNo == "") {
        displayAlertMessage('danger', `Please Select Batch No !`)
        return
      }

      if (FzLoccode == "") {
        displayAlertMessage('danger', `Please Select Location !`)
        return
      }

      SavePostAdj()

    } else { //stock freeze function

      if (addNew == true && nullCode == false) {
        SetFzBatchNo(autoCode)
      }

      if (strLocation.length == 0) {
        displayAlertMessage('danger', `Please Select Location !`)
        return
      }

      if (selectedTxn.length == 0) {
        displayAlertMessage('danger', `Please Select Transaction Type !`)
        return
      }


      if (grpData.length < 1) {
        displayAlertMessage('danger', `Please load items before freeze items !`)
        return
      }

      var lstGroups = []

      lstGroups = await LoadSelectedGroups()


      // Usage examples
      const myData = new Date();
      const myDateTime = formatDate(myData, true); // Full date-time format
      const myDateOnly = formatDate(myData);       // Date only format


      let raw = JSON.stringify({
        "strHED_TYPE": selectedTxn,
        "strHED_REFTYPE": "",
        "strHED_RUNNO": "NAN",
        "dtHED_TXNDATE": myDateOnly,
        "dtHED_TIME": myDateTime,
        "strHED_SETUPLOC": "",
        "strHED_LOCFROM": strLocation,
        "strHED_LOCTO": "",
        "strHED_LOCDEL": "",
        "strHED_COMCODE": LogCompanyCode,
        "strHED_PRIECMODE": "",
        "strHED_CUSCODE": "",
        "strHED_LOC": strLocation,
        "strHED_SUPCODE": strVendor,
        "strHED_REFNO": "",
        "strHED_REF1": remarks,
        "strHED_REF2": "",
        "dcHED_SELLAMT": 0,
        "dcHED_GROAMT": 0,
        "dcHED_DISCPER": 0,
        "dcHED_ITAXAMT": 0,
        "dcHED_ETAXAMT": 0,
        "dcHED_ADDAMT": 0,
        "dcHED_DEDAMT": 0,
        "dcHED_NETAMT": 0,
        "dcHED_RECCOUNT": 0,
        "dcHED_REFCOUNT": 0,
        "intHED_PROCESSED": 0,
        "intHED_LOCKED": 0,
        "intHED_CANCELLED": 0,
        "dtHED_CANDATE": "2019-01-01",
        "strHED_CANUSER": "",
        "dcHED_PRINTCOUNT": 0,
        "dcHED_REFDOCVAL": 0,
        "intHED_FULLYUSED": 0,
        "intHED_EXPORT": 0,
        "strHED_EXPBATCH": "",
        "dtHED_BEFOREDATE": "2019-01-01",
        "dtHED_AFTERDATE": "2019-01-01",
        "strHED_EXTREFDOC": "",
        "stockGroupSets": lstGroups,
        "strCR_BY": LogUserType,
        "strMenuCode": menuCode,
        "strLoggedCompany": LogCompanyCode,
        "strLoggedLocation": LocationCode,
        "strReason": Reason,
      })
      var myHeaders = new Headers()
      myHeaders.append("Content-Type", "application/json")
      myHeaders.append("Authorization", `Bearer ${authToken}`)

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
        body: raw,
      }

      SetLoadingAlert(true)
      SetLoadingAlerttitle("Saving...")

      fetch(`${ApiURL}stockfreeze`, requestOptions)
        .then(response => response.json())
        .then(result => {
          SetLoadingAlert(false)
          if (result.success == true) {
            if (result.data == "0") {
              ClearItem()
              displayAlertMessage('success', "Save Success. Document No is " + result.doc)

            } else {
              displayAlertMessage('danger', result.doc)
            }
          } else if (result.success == false) {
            displayAlertMessage('danger', result.doc)
          }
        })
        .catch(error => {
          SetLoadingAlert(false)
          console.log("error", error)
        })
    }
  }

  //*** Get user selected row details */
  const GetSelectRow = (row, isSelect, rowIndex, e) => { }
  //*** End of getSelectedRow function */

  //edit button function
  const handleEdit = e => { }

  //new button function
  const handleNew = e => {
    //e.preventDefault()
    ClearItem()
    setShow(false)
    setSaveEnable(true)
    setCrEnable(false)
  }

  //clear fields function
  const ClearItem = () => {
    SetBatch("")
    SetLocation("")
    SetLocationDesc("")
    setSelectedTxn("")
    SetVendor("")
    SetVendorDesc("")
    setGrpData([])
    SetFzBatchNo("")
    SetFzLoccode("")
    setTxnType("")
    setRemarks("")
    setClearChange(prev => !prev)
    setAddZero(false)
  }

  //********Delete button function */
  const handleDelete = () => { }
  //*********Delete button function end */
  // print Function
  async function handlePrint(option) {
    var option = option

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")

    const ReportURL = window.Links.ReportURL

    if (viewRpt == "1") {

      await fetch(`${ReportURL}api/StockFreeze/reportFZ/${LogUserType}/${FzBatchNo}/${FzLoccode}/${option == 'PDF' ? 1 : 0}/${txnType}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      ).then(Response => Response.json())
        .then(responseData => {
          if (responseData.success == true) {
            if (option == "PDF") {
              const msg = responseData.msg
              window.open(
                `${ReportURL}temp_print/${msg.replace("\r\n", "")}.pdf`
              )
            } else {
              const msg = responseData.msg
              window.open(
                `${ReportURL}temp_print/${msg.replace("\r\n", "")}.xlsx`
              )
            }
          }
          SetLoadingAlert(false)
        })

    } else if (viewRpt == "2") {
      handlePrintSV(option)

    } else if (viewRpt == "3") {
      SetLoadingAlert(false)
    } else if (viewRpt == "4") {
      SetLoadingAlert(false)
    } else {
      SetLoadingAlert(false)
    }
  }


  function formatDate(date, includeTime = false) {
    // Function to add leading zero
    const pad = (value) => (value < 10 ? '0' + value : value);

    // Extract date components
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Month is zero-indexed
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    // Construct the formatted date string
    if (includeTime) {
      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    } else {
      return `${year}-${month}-${day}`;
    }
  }





  async function handlePrintSV(option) {
    var option = option


    if (FzBatchNo == "" || FzLoccode == "") {
      displayAlertMessage('danger', `Please Select Batch No and Location !`)
      return
    }


    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")


    const ReportURL = window.Links.ReportURL
    await fetch(
      `${ReportURL}api/StockFreeze/reportSV/${LogUserType}/${FzBatchNo}/${FzLoccode}/${option == 'PDF' ? 1 : 0}/${txnType}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }
    ).then(Response => Response.json())
      .then(responseData => {
        if (responseData.success == true) {
          if (option == "PDF") {
            const msg = responseData.msg
            window.open(
              `${ReportURL}temp_print/${msg.replace("\r\n", "")}.pdf`
            )
          }
          if (option == "XCEL") {
            const msg = responseData.msg
            window.open(
              `${ReportURL}temp_print/${msg.replace("\r\n", "")}.xlsx`
            )
          }
        }
        SetLoadingAlert(false)
      }).catch(error1 => {
        console.log(error1)
        SetLoadingAlert(false)
      }).catch(error2 => {
        console.log(error2)
        SetLoadingAlert(false)
      })
  }

  async function handlePrintSVH(option) {
    var option = option

    if (FzBatchNo == "" || FzLoccode == "") {
      setAlertColor("danger")
      setAlertMsg(`Please Select Batch No and Location !`)
      setShow(true)
      setTimeout(() => {
        setShow(false)
      }, time)
      return
    }


    SetLoadingAlert(true)
    SetLoadingAlerttitle("Generating Report...")

    const ReportURL = window.Links.ReportURL
    await fetch(
      `${ReportURL}api/StockFreeze/reportSVH/${LogUserType}/${FzBatchNo}/${FzLoccode}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
      .then(Response => Response.json())
      .then(responseData => {

        if (responseData.success == true) {
          if (option == "PDF") {
            const msg = responseData.msg
            window.open(
              `${ReportURL}temp_print/${msg.replace("\r\n", "")}.pdf`
            )
          }
          if (option == "XCEL") {
            const msg = responseData.msg
            window.open(
              `${ReportURL}temp_print/${msg.replace("\r\n", "")}.xlsx`
            )
          }
        }
        SetLoadingAlert(false)
      }).catch(error1 => {
        console.log(error1)
        SetLoadingAlert(false)
      }).catch(error2 => {
        console.log(error2)
        SetLoadingAlert(false)
      })
  }

  async function SavePostAdj() {

    var obje = {
      "batch": FzBatchNo,
      "txntype": txnType,
      "zeroenable": addZero,
      "location": FzLoccode,
      "logcompany": LogCompanyCode,
      "loglocation": LocationCode,
      "loguser": LogUserType,
    }

    SetLoadingAlert(true)
    SetLoadingAlerttitle("Saving...")

    await fetch(
      `${ApiURL}StockFreeze/savePSA`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(obje),
      }
    ).then(Response => Response.json())
      .then(result => {
        SetLoadingAlert(false)
        if (result.success == true) {
          displayAlertMessage('success', "Save Success. Document No is " + result.doc)
          ClearItem()

        } else if (result.success == false) {
          displayAlertMessage('danger', result.doc)
        }
        // console.log(option)
      }).catch(error1 => {
        SetLoadingAlert(false)
        console.log(error1)
      }).catch(error2 => {
        SetLoadingAlert(false)
        console.log(error2)
      })
  }

  //**Permission Check */
  const permission = operation => {
    const permissiondata = {
      strUsername: permissionName,
      strPassword: permissionPassword,
      strLocation: LocationCode,
      strMenuCode: menuCode,
    }


    fetch(`${ApiURL}login/userpermission`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(permissiondata),
    })
      .then(Response => {
        if (Response.status == "200") {
          Response.json().then(responseData => {
            console.log(responseData.data)
            let Access = responseData.data.strMenuAccessRight
            let Create = responseData.data.strMenuCreateRight
            let Delete = responseData.data.strMenuDeleteRight
            let Modify = responseData.data.strMenuModifyRight
            let Print = responseData.data.strMenuPrintRight
            let Process = responseData.data.strMenuProcessRight

            if (operation == "Save") {
              if (Create == true) {
                handlesave()
              } else if (Modify == true) {
                handlesave()
              } else {
                if (operation == "Save" && addNew == true) {
                  displayAlertMessage('danger', "This user dosen't have permission to save")

                } else {
                  displayAlertMessage('danger', "This user dosen't have permission to edit")

                }
              }
            } else if (operation == "Delete") {
              if (Delete == true) {
                handleDelete()
              } else {
                displayAlertMessage('danger', "This user don't have permission to delete !")

              }
            } else if (operation == "Print") {
              if (Print == true) {
                setprintoptionShow(true)
              } else {
                displayAlertMessage('danger', "This user don't have permission to print !")
              }
            }
          })
        } else if (Response.status == "400") {
          Response.json().then(responseData => {
            setErrorMsg(responseData.msg)
          })
          setDisabled(false)
          setDisabledCode(false)
          clearPermissionInputs()
          displayAlertMessage('danger', "Oops something went wrong !")

        } else if (Response.status == "403") {
          Response.json().then(responseData => {
            setErrorMsg(responseData.msg)
          })
          setDisabled(false)
          setDisabledCode(false)
          displayAlertMessage('danger', "You have not Permission to make changes !")
          clearPermissionInputs()

        } else if (Response.status == "404") {
          Response.json().then(responseData => {
            setErrorMsg(responseData.msg)
          })
          setDisabled(false)
          setDisabledCode(false)
          displayAlertMessage('danger', "Password or User Name is Invalid !")
          clearPermissionInputs()

        } else {
          ClearItem()
        }
      })
      .catch(error => {
        console.log(error.message)
      })
  }


  async function getLocations(locCode) {

    const locations = await getLocation(locCode)
    if (locations.length > 0) {
      SetLocation(locations[0].code)
      SetLocationDesc(locations[0].name)
    } else {
      SetLocation("")
      SetLocationDesc("")
    }

  }


  async function getSuppliers(supCode) {

    const suppliers = await getSupplier(supCode)
    if (suppliers.length > 0) {
      SetVendor(suppliers[0].code)
      SetVendorDesc(suppliers[0].name)
    } else {
      SetVendor("")
      SetVendorDesc("")
    }

  }


  //Function for display Alert Messages
  function displayAlertMessage(color, message) {
    setAlertColor(color)
    setAlertMsg(message)
    setShow(true)

    setTimeout(() => {
      setShow(false)
    }, time)
  }


  //handle permission alert
  function handlePermissionAlert(LogUserType, reason, disable, alertShow) {
    setPermissionName(LogUserType)
    setReason(reason)
    setPermissionNameDisable(disable)
    setPermissionAlertShow(alertShow)
  }


  //Clear permission name & password
  function clearPermissionInputs() {
    setPermissionName("");
    setPermissionPassword("");
    setReason("");
  }


  //Handle Favourite Button
  const handleFavourite = async () => {
    var response = await addtoFavourite(menuCode, LogUserType);
    console.log(response)
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{menuName}</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumb title={parentName} breadcrumbItem={menuName}></Breadcrumb>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <DPAlert
                    confirm_both={sweetAlertShow}
                    title={menuName}
                    description={AlertDescription}
                    showCancel={true}
                    btnColor={"success"}
                    cancelColor={"danger"}
                    onConfirm={() => {
                      setsweetAlertShow(false)
                      if (AlertConfirmOption == 1) {
                        if (
                          addNew == true &&
                          menuCreate == true &&
                          permissionReasonShow == false
                        ) {
                          handlesave()
                        } else if (
                          addNew == true &&
                          menuCreate == true &&
                          permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Created", true, true)
                        } else if (
                          addNew == false &&
                          menuModify == true &&
                          permissionReasonShow == false
                        ) {
                          handlesave()
                        } else if (
                          addNew == false &&
                          menuModify == true &&
                          permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Updated", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      } else if (AlertConfirmOption == 2) {
                        handleEdit()
                      } else if (AlertConfirmOption == 3) {
                        window.location.href = "/"
                      } else if (AlertConfirmOption == 4) {
                        handleNew()
                      } else if (AlertConfirmOption == 6) {
                        if (
                          menuPrint == true &&
                          permissionReasonShow == false
                        ) {
                          setprintoptionShow(true)
                        } else if (
                          menuPrint == true &&
                          permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Printed", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      } else if (AlertConfirmOption == 5) {
                        if (
                          addNew == false &&
                          menuDelete == true &&
                          permissionReasonShow == false
                        ) {
                          handleDelete()
                        } else if (
                          addNew == false &&
                          menuDelete == true &&
                          permissionReasonShow == true
                        ) {
                          handlePermissionAlert(LogUserType, "Deleted", true, true)
                        } else {
                          setPermissionReasonShow(true)
                          setPermissionAlertShow(true)
                        }
                      } else if (AlertConfirmOption == 7) {
                        setAddZero(true)
                      }
                    }}
                    onCancel={() => {
                      setsweetAlertShow(false)
                      if (AlertConfirmOption == 7) {
                        setAddZero(false)
                      }
                    }}
                  />
                  <DPPrintOption
                    confirm_both={printoptionShow}
                    title={menuName}
                    description={permissionAlertTitle}
                    showReason={permissionReasonShow}
                    nameDisable={permissionNameDisable}
                    showCancel={true}
                    excelOnly={true}
                    cancelColor={"danger"}
                    onConfirmpdf={() => {
                      handlePrint("PDF")
                      setprintoptionShow(false)
                    }}
                    onConfirmxcel={() => {
                      handlePrint("XCEL")
                      setprintoptionShow(false)
                    }}
                    onCancel={() => {
                      setprintoptionShow(false)
                    }}
                  />
                  <DPPermission
                    confirm_both={permissionAlertShow}
                    title={menuName}
                    description={permissionAlertTitle}
                    showReason={permissionReasonShow}
                    nameDisable={permissionNameDisable}
                    showCancel={true}
                    btnColor={"success"}
                    cancelColor={"danger"}
                    AlName={permissionName}
                    AlNameOnchange={e => {
                      let val2 = Text(e.target, 50, true, false, "any", true)
                      setPermissionName(val2)
                    }}
                    AlPassward={permissionPassword}
                    AlPasswardOnchange={e => {
                      let val2 = Text(e.target, 50, true, true, "any", true)
                      setPermissionPassword(val2)
                    }}
                    AlReason={Reason}
                    AlReasonOnchange={e => {
                      let val2 = Text(e.target, 50, true, false, "any", true)
                      setReason(val2)
                    }}
                    onConfirm={() => {
                      setPermissionAlertShow(false)
                      if (AlertConfirmOption == 1) {
                        permission("Save")
                      } else if (AlertConfirmOption == 5) {
                        permission("Delete")
                      } else if (AlertConfirmOption == 6) {
                        permission("Print")
                      }
                    }}
                    onCancel={() => {
                      setPermissionAlertShow(false)
                      clearPermissionInputs()

                    }}
                  />
                  <DPLoadingAlert
                    confirm_both={loadingAlert}
                    title={loadingAlertTitle}
                  />
                  <DPTopToolBar
                    //Help Button
                    helpEnable={helpUrl != "" ? true : false}
                    helpClick={() => {
                      window.open(helpUrl)
                    }}
                    //Favorite Button
                    favoriteEnable={true}
                    favoriteClick={handleFavourite}
                    //New Button
                    newEnable={true}
                    newClick={() => {
                      setAlertDescription("Do you wish to refresh the screen ?")
                      setAlertConfirmOption(4)
                      setsweetAlertShow(true)
                    }}
                    //Save Button
                    saveEnable={customActiveTab == "2" && viewRpt != '4' ? false : saveEnable}
                    saveClick={() => {
                      setAlertDescription("Do you wish to save ?")
                      setAlertConfirmOption(1)
                      setsweetAlertShow(true)
                    }}
                    //ProcessButton
                    processEnable={false}
                    processClick={() => {
                      alert("Process")
                    }}
                    //Edit Button
                    editEnable={customActiveTab == "2" ? false : editEnable}
                    editClick={() => {
                      setAlertDescription("Do you wish to edit ?")
                      setAlertConfirmOption(2)
                      setsweetAlertShow(true)
                    }}
                    //Print Button
                    printEnable={customActiveTab == "2" ? true : false}
                    printClick={() => {
                      setReason("Printed")
                      setAlertDescription("Do you wish to print ?")
                      setAlertConfirmOption(6)
                      setsweetAlertShow(true)
                    }}
                    //Delete Button
                    deleteEnable={deleteEnable}
                    deleteClick={() => {
                      setReason("Deleted")
                      setAlertDescription("Do you wish to delete ?")
                      setAlertConfirmOption(5)
                      setsweetAlertShow(true)
                    }}
                    //Exit Button
                    exitEnable={true}
                    exitClick={() => {
                      setAlertDescription("Do you wish to exit ?")
                      setAlertConfirmOption(3)
                      setsweetAlertShow(true)
                    }}
                  />
                  <Row>
                    {show ? (
                      <Alert color={AlertColor} role="alert">
                        {AlertMsg}
                        <br />
                        {/*<small>{ErrorMsg}</small>*/}
                      </Alert>
                    ) : null}
                    <DPNavBar
                      buttons={tabList}
                      activeStatus={customActiveTab}
                    />
                    <TabContent
                      activeTab={customActiveTab}
                      className="p-3 text"
                    >
                      <TabPane tabId="1">
                        <StockFreezeContent
                          DescValue={strBatch}
                          DescOnChange={e => {
                            let valCode = Text(
                              e.target,
                              50,
                              true,
                              true,
                              "any",
                              true
                            )
                            SetBatch(valCode)
                          }}
                          Gen_strLocation={strLocation}
                          Gen_blLocationEnable={blLocationEnable}
                          Gen_IsLocation={IsLocation}
                          Gen_Location_OnChange={e => {
                            SetLocation(e["value"])
                          }}
                          Gen_Location_Blur={e => {

                            if (e.target.value != "") {
                              getLocations(e.target.value)
                            } else {
                              SetLocation("")
                              SetLocationDesc("")
                            }

                          }}
                          remarks={remarks}
                          remarksOnChange={e => {
                            setRemarks(e.target.value)
                          }}
                          SwLocationonChange={() => {
                            SetIsLocation(!IsLocation)
                          }}
                          Gen_strVendor={strVendor}
                          Gen_blVendorEnable={blVendorEnable}
                          Gen_IsVendor={IsVendor}
                          Gen_Vendor_OnChange={e => {
                            let valCode = Text(
                              e.target,
                              200,
                              true,
                              true,
                              "any",
                              true
                            )
                            SetVendor(valCode)
                          }}
                          Gen_Vendor_Blur={e => {
                            if (e.target.value != "") {
                              getSuppliers(e.target.value)
                            } else {
                              SetVendor("")
                              SetVendorDesc("")
                            }
                          }}
                          SwVendoronChange={() => {
                            SetIsVendor(!IsVendor)
                          }}
                          SearchModelOpenLoc={modal_xlargeLoc}
                          SearchModelTriggerLoc={tog_xlargeLoc}
                          SearchGetSelectRowLoc={GetSelectRowLoc}

                          SearchModelOpenVen={modal_xlargeVen}
                          SearchModelTriggerVen={tog_xlargeVen}
                          SearchGetSelectRowVen={GetSelectRowVen}
                          menuCode={menu}
                          loadItems={loadItems}
                          showFileUpload={e => {
                            const file = e.target.files[0]
                            readExcel(file)
                            setvalueUpload(e.target.value)
                          }}
                          valueUpload={valueUpload}
                          strLocationDesc={strLocationDesc}
                          strVendorDesc={strVendorDesc}
                          txnTypes={txnTypes}
                          selectedTxn={selectedTxn}
                          handleTxnChange={e => {
                            setSelectedTxn(e["value"])
                          }}
                          GrpData={grpData}
                          allLocations={allLocations}
                        />
                        <hr />
                        <StockFreezeGroup
                          Disabled={disabled}
                          DataRow={optionGroup}
                          menuCode={menuCode}
                          clearChange={clearChange}
                          groupCodeData={groupCodeData}
                          setGroupCodeData={setGroupCodeData}
                          GrpData={grpData}
                        />
                        <hr />
                        <Row>
                          <Col sm={12} md={2} className="mb-4-sm">
                            <Button
                              onClick={() => {
                                loadItems()
                              }}
                              color="success"
                              className="btn-sm"
                              disabled={disabled ? true : grpData.length > 0 ? true : false}
                            >
                              Load Products
                            </Button>
                          </Col>
                        </Row>
                        <hr />
                        <StockFreezeProducts DataRow={grpData} />
                      </TabPane>
                      <TabPane tabId="2">
                        <StockCountSheet
                          BatchSelect={BatchSelect}
                          LocationSelect={LocationSelect}
                          Gen_strBatch={FzBatchNo}
                          Gen_Batch_OnChange={e => {
                            let valCode = Text(
                              e.target,
                              50,
                              true,
                              true,
                              "any",
                              true
                            )
                            SetFzBatchNo(valCode)
                          }}
                          Gen_strLocation={FzLoccode}
                          Gen_Location_OnChange={e => {
                            SetFzLoccode(e["value"])
                            SetFzBatchNo("")
                          }}
                          tog_xlargeB={tog_xlargeB}
                          tog_xlargeL={tog_xlargeL}
                          modal_xlargeB={modal_xlargeB}
                          modal_xlargeL={modal_xlargeL}
                          menuCode={menuCode}
                          handlePrintSV={handlePrintSV}
                          handlePrintSVH={handlePrintSVH}
                          viewRpt={viewRpt}
                          setViewRpt={(e) => {
                            setViewRpt(e)
                            SetFzBatchNo("")
                            SetFzLoccode("")
                            setTxnType("")
                            ClearItem()
                          }}
                          addZero={addZero}
                          setAddZero={setAddZero}
                          setAlertConfirmOption={setAlertConfirmOption}
                          setAlertDescription={setAlertDescription}
                          setsweetAlertShow={setsweetAlertShow}
                          allLocations={allLocations}
                          setTxnTypeOnChange={(e) => {
                            setTxnType(e["value"])
                            SetFzBatchNo("")
                          }}
                          txnType={txnType}
                          txnTypes={txnTypes}
                        />
                      </TabPane>
                    </TabContent>
                  </Row>
                  <Row>
                    {crEnable ? (
                      <DPInfoBox
                        createdBy={crBy}
                        createdOn={
                          crDate != "1900-01-01T00:00:00" ? crDate : ""
                        }
                        modifiedBy={mdBy}
                        modifiedOn={
                          mdDate != "1900-01-01T00:00:00" ? mdDate : ""
                        }
                      />
                    ) : null}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default StockFreeze
